import base from './base'

export default {
  ...base,
  colors: {
    ...base.colors,
    shadow1: '#2F80ED',
    // text1: '#443e3e',
    text1: 'rgb(227, 245, 246)',
    text2: '#51ccc5',
    // text3: '#888D9B',
    text3: '#A4C1CA',
    text4: '#C3C5CB',
    lightText: '#1FFFFF',

    // backgrounds / greys
    bg0: 'rgb(244, 247, 250)',
    // bg1: '#fff',
    bg1: '#21343E',
    bg2: '#F5F3F3',
    bg3: '#EDEEF2',
    bg4: '#CED0D9',
    bg5: '#C4C4C4',
    modalBG: 'rgba(0,0,0,0.3)',
    advancedBG: 'rgba(255,255,255,0.6)',

    //primary colors
    primary1: '#51ccc5',
    primary4: '#bfe0e2',
    primary5: '#daedef',

    // color text
    primaryText1: '#13aab5',
    buttonText: '#ffffff',

    // secondary colors
    secondary1: '#13aab5',
    bg: '#FFFFFF',
    cardBg: '#fff',
    cardBg2: '#F2F2F2',
    cardBg3: '#ECEFFF',
    cardBg4: '#F6F6F6',
    cardBg5: '#3D3D3D',
    primary: '#51ccc5',
    secondary: '#6E84FB',
    normal: '#000',
    inputBg: '#FFF9F0',
    strokColor: '#E1E1E1',
    navBg: '#C4C4C4'
  }
}
